const isLocal = process.env.REACT_APP_FUNC_URL!.includes("localhost");

export const baseUrl = isLocal
  ? process.env.REACT_APP_FUNC_URL
  : `https://${process.env.REACT_APP_FUNC_URL}.azurewebsites.net/api`;
export const code = isLocal ? "" : process.env.REACT_APP_FUNC_KEY;

export const sections = "/sections";
export const planogrammes = "/planogrammes";
export const modele = "/modele";
export const collection = "/collection";
export const produit = "/planogramme/produit";
export const secCombo = "/sections/combo";
export const fournisseur = "/fournisseur";
export const divisions = "/divisions";
export const statut = "/statut";
export const magasins = "/magasins";
export const bannieres = "/banniere";
export const activites = "/activite";
export const users = "/usager";
export const vise = "/planogramme/vise";
export const secMagasin = "/section/magasin";
export const planogramme = "/planogramme";
export const selection = "/sections/selection";
export const magasin = "/sections/magasin";
export const login = "/auth/login";
export const stats = "/planogramme/stats";
export const acheteur = "sections/acheteur";
export const produit_section = "/planogramme/produit/section";
export const planogramme_produit = "/planogramme/produits";
export const ensemble = "/planogramme/ensemble";
